import Layout from '@/layout/layout'

const featureRouter = {
    path: '/inventoryManagement',
    component: Layout,
    redirect: 'noRedirect',
    name: '库存管理',
    children: [{
            path: 'machineOld',
            component: () => import('@/views/inventoryManagement/machineOld/index'),
            name: '在库旧机',
            meta: {
                title: '在库旧机',
                noCache: true
            }
        },
        {
            path: 'stringTracking',
            component: () => import('@/views/inventoryManagement/stringTracking/index'),
            name: '旧机跟踪',
            meta: {
                title: '旧机跟踪',
                noCache: true
            }
        },
    ]
}

export default featureRouter